import { Reducer } from 'redux'
import { FTRAssessmentForm } from './actions'

export interface FTRQuestion {
  questionId: string
  pillarId: string
  questionTitle: string
  status?: string
  questionReferenceNumber: string
}

export enum FTRAssessmentSectionName {
  PAGE_MARKER = 'pageMarker',
  CREATE_ASSESSMENT_INFORMATION = 'createAssessmentInfo',
}

export interface CreateFTRAssessmentResponse {
  assessmentId: string
  partnerId: string
}
export interface CreateFTRAssessmentRequest {
  name: string
  description: string
  workloadType?: string
  workloadName?: string
  assessmentType?: string
  assessmentId?: string
  scope: AWSScopes[]
}

export interface FTRAssessmentFormDetails {
  id: string
  name: string
  description: string
  workloadType?: string
  workloadName?: string
  assessmentType?: string
  assessmentId?: string
  scope: AWSScopes[]
  assessmentTypeId?: string
  createdAt?: string
  updatedAt?: string
  answered?: string
  flagged?: string
  unanswered?: string
  partnerId?: string
  productRunOn?: string
  progressBarPercentage?: number
  solutionHostedOn?: string
  status?: string
  reportTimestamp?: string
  staffId?: string
}

export interface AwsRegions {
  region: string
  regionName: string
}

export interface AWSScopes {
  accountId: string
  awsRegions: string[] | AwsRegions[]
}
export type ScopeItem = {
  accountId: string
  awsRegions: string[]
}

export interface AwsAccountDetails {
  awsAccountId: string
  awsAccountRegion: AwsRegions[]
}

export type Sections = {
  [FTRAssessmentSectionName.CREATE_ASSESSMENT_INFORMATION]: FTRAssessmentFormDetails
}

export interface FTRCreateAssessmentState {
  createAssessmentForm: Sections
}

export const initialState: FTRCreateAssessmentState = {
  createAssessmentForm: {} as Sections,
}

type actionType = {
  type: FTRAssessmentForm.SET_FTR_CREATE_ASSESSMENT_FORM
  payload: Sections | string
}

export const reducer: Reducer<FTRCreateAssessmentState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FTRAssessmentForm.SET_FTR_CREATE_ASSESSMENT_FORM: {
      return {
        ...state,
        createAssessmentForm: action.payload as Sections,
      }
    }
    default: {
      return state
    }
  }
}
